import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, firstValueFrom, of, timeout, catchError } from 'rxjs';
import { PermissionService } from '../../features/security/services/permission.service';

export const superAdminGuard: CanActivateFn = async () => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    // Wait for permissions to be initialized (same pattern as permissionGuard)
    if (permissionService.loading() || !permissionService.initialized()) {
        if (!permissionService.loading() && !permissionService.initialized()) {
            permissionService.loadPermissions();
        }
        try {
            await firstValueFrom(
                toObservable(permissionService.initialized).pipe(
                    filter(init => init),
                    timeout(8000),
                    catchError(() => of(false))
                )
            );
        } catch {
            return router.createUrlTree(['/login']);
        }
    }

    if (permissionService.isSuperAdmin()) {
        return true;
    }

    // Non-super-admin without a company → onboarding, not dashboard
    const hasCompany = !!localStorage.getItem('selectedCompanyId');
    return router.createUrlTree([hasCompany ? '/dashboard' : '/onboarding']);
};
